export interface APIClientConfig {
    baseUrl: string;
    tenant: string;
    requestor: string;
    accessToken: string;
    headers: HeadersInit;
}

/* Base class for API clients, which handles common functionality like adding
 * headers and query params. */
export class APIClient extends EventTarget {
    constructor(protected config: APIClientConfig) {
        super();
    }

    protected getUrlWithParams(endpoint: string): string {
        const url = new URL(`${this.config.baseUrl}${endpoint}`);
        url.searchParams.append('tenant', this.config.tenant);
        url.searchParams.append('requestor', this.config.requestor);
        return url.toString();
    }

    public async fetchJSON<T>(
        endpoint: string,
        options: RequestInit,
        requestId?: string
    ): Promise<T> {
        try {
            this.dispatchEvent(new CustomEvent('start', { detail: { requestId } }));

            const response = await fetch(this.getUrlWithParams(endpoint), {
                ...options,
                headers: {
                    ...this.config.headers,
                    Authorization: `Bearer ${this.config.accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Request failed`);
            }

            // Check if response has content
            let data: T | null = null;
            const contentLength = response.headers.get('Content-Length');
            if (contentLength === null || parseInt(contentLength) > 0) {
                data = await response.json();
            }

            this.dispatchEvent(new CustomEvent('success', { detail: { data, requestId } }));
            return data as T;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            this.dispatchEvent(
                new CustomEvent('error', { detail: { error: error.message, requestId } })
            );
            throw error;
        }
    }
}
